import { IBasicWorkerInitializationMessageData } from "OW.Remoting/Basic/BasicWorker";
import { ICommunicationInitializationMessageData } from "OW.Remoting/Basic/WorkerMessages";

export interface IWorkerInitializationMessageData extends ICommunicationInitializationMessageData, IBasicWorkerInitializationMessageData {
    readonly appId: string;
}
